var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBitbucket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.81794 1.87505C1.6523 1.87284 1.49419 1.94639 1.38602 2.07595C1.27786 2.20552 1.23072 2.37784 1.25724 2.5467L3.63742 17.4677C3.69864 17.8447 4.01308 18.1218 4.38315 18.1249H15.8019C16.0796 18.1286 16.3181 17.9217 16.3626 17.6386L18.7427 2.54959C18.7693 2.38074 18.7221 2.20841 18.614 2.07884C18.5058 1.94928 18.3477 1.87574 18.1821 1.87794L1.81794 1.87505ZM11.8405 12.6591H8.19594L7.20912 7.33512H12.7236L11.8405 12.6591Z",
    fill: "#2684FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9864 7.33517H12.7241L11.8411 12.6592H8.19649L3.89307 17.934C4.02946 18.0557 4.20337 18.1235 4.38368 18.125H15.8052C16.083 18.1287 16.3215 17.9219 16.3659 17.6387L17.9864 7.33517Z",
    fill: "url(#paint0_linear_399_2310)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_399_2310",
    x1: 19.2031,
    y1: 8.82611,
    x2: 12.8605,
    y2: 17.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitbucket);
export default __webpack_public_path__ + "static/media/bitbucket.3ca34562caad4d32b9621fd3a5eaeb70.svg";
export { ForwardRef as ReactComponent };